import React, { useState } from 'react'
import { BranchContext } from './BranchContext'
import { OrganizationBranchDataFragment } from '../generated/graphql'

export const BranchProvider: React.FC = ({ children }) => {
  const [branch, setBranch] = useState<OrganizationBranchDataFragment | null>(null)
  return <BranchContext.Provider value={{ branch, setBranch }}>{children}</BranchContext.Provider>
}
